import AskAiButtonContentMcom from './AskAIButtonContent.mcom.vue';
import AskAIButtonContentBcom from './AskAIButtonContent.bcom.vue';

export default import.meta.env.VITE_ENTRY_POINT === 'bcom' ? AskAIButtonContentBcom : AskAiButtonContentMcom;
